import { useEffect, useRef } from 'react'

/**
 * Зовёт `onVisible`, когда метка подходит к краю экрана — с запасом, чтобы
 * следующая порция успела приехать до того, как палец её догонит. Пока
 * `enabled` выключен (грузится или грузить нечего), метка не следит.
 * Без IntersectionObserver ничего не делает: остаётся кнопка рядом с меткой.
 */
export function useOnVisible(onVisible: () => void, enabled: boolean) {
  const ref = useRef<HTMLDivElement>(null)
  const latest = useRef(onVisible)
  useEffect(() => {
    latest.current = onVisible
  })

  useEffect(() => {
    if (!enabled || typeof IntersectionObserver === 'undefined') return
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) latest.current()
      },
      { rootMargin: '0px 0px 600px 0px' },
    )
    observer.observe(ref.current as HTMLDivElement)
    return () => {
      observer.disconnect()
    }
  }, [enabled])

  return ref
}
